import { notification } from '@pu/mpp-ui/notifications';
import { IUpdateShortcutRequest } from 'core/model/interfaces/shortcuts/shortcuts-form.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { SLICE_NAMESPACE } from '../shortcuts.constants';
import { IShortcutsState } from '../shortcuts.types';
import { fetchShortcuts } from './fetchShortcuts';

export const updateShortcut = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/updateShortcut`,
  async (params: IUpdateShortcutRequest, { dispatch }) => {
    try {
      await apiService.shortcuts.updateShortcut(params);

      notification.success('El shortcut ha sido modificado correctamente.');

      await dispatch(fetchShortcuts());
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Ocurrió un error al actualizar el shortcut.');

      showNotificationError(errorMessage);
      throw error;
    }
  },
);

export const updateShortcutReducer: TSliceExtraReducer<IShortcutsState> = builder =>
  builder
    .addCase(updateShortcut.pending, state => {
      state.form.isLoading = true;
      state.form.isSuccess = false;
    })
    .addCase(updateShortcut.rejected, state => {
      state.form.isLoading = false;
      state.form.isSuccess = false;
    })
    .addCase(updateShortcut.fulfilled, state => {
      state.form.isLoading = false;
      state.form.isSuccess = true;
    });
